import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    GET_PRODUCTSTEMPLATESFILTER_SUCCESS,
    GET_PRODUCTSTEMPLATESFILTER_FAILURE,
} from '../actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getProductsTemplates() {
    const url = 'productsTemplatesFilter';
    try {
        const result = yield axios
            .get(url)
            .then((response) => response.data);
        yield put({
            type: GET_PRODUCTSTEMPLATESFILTER_SUCCESS,
            productsTemplatesFilter: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: {}
        });
        yield put({
            type: GET_PRODUCTSTEMPLATESFILTER_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
